import React, { PropTypes } from 'react'
import classNames from 'classnames'
import styles from './style.styl'

export default function CTAButton(props) {
  const {
    className,
    onClick,
    href,
    style,
    primaryColor,
    secondaryColor,
    ...rest,
  } = props
  const ComponentClass = href ? 'a' : 'button'
  const target = href ? '_blank' : undefined
  return (
    <ComponentClass className={classNames(
                      styles.CTAButton,
                      'dsg-LargeButton',
                      'bg-teal',
                      className
                    )}
                    style={{
                      ...style,
                      backgroundColor: primaryColor,
                      color: secondaryColor,
                    }}
                    onClick={onClick}
                    href={href}
                    target={target}
                    {...rest}/>
  )
}
CTAButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  href: PropTypes.string,
  onClick: PropTypes.func,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  style: PropTypes.object,
}
CTAButton.defaultProps = {
  style: {},
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/CTAButton/index.js